import { createReduxOperation } from "src/store/utils";
import { LoginActionPayload } from "./types";
import * as api from "src/api/authenticate";
import { setShowSnackbar } from "src/store/app";
import userService from "src/shared/services/user.service";
import anomalyIndicatorService from "src/shared/services/anomalyIndicator.service";
import { ThunkResult } from "src/shared/types";
import { getXClientIdHeader, ServiceName } from "src/utils/getservicename";
import { getUserRoles } from "src/api/app";

const {
  actions: [authRequest, authSuccess, authFailure],
  reducer: authenticationReducer,
} = createReduxOperation("AUTHENTICATE");

export function loginAction({ token, callbackFn }: LoginActionPayload): ThunkResult<Promise<void>> {
  return async (dispatch) => {
    dispatch(authRequest());
    const { response, error } = await api.login(token);
    if (response) {
      dispatch(authSuccess());
      userService.token = response.headers.get("Access-Token");
      callbackFn();
      setTimeout(() => {
        dispatch(setShowSnackbar(anomalyIndicatorService.shouldShow));
        anomalyIndicatorService.incrementVisitedCount();
      }, 2000);
    } else {
      dispatch(authFailure(error));
    }
  };
}

export function logoutAction(): ThunkResult<Promise<void>> {
  return async () => {
    await api.logout();
  };
}

export function validateAccess(userRoles): boolean{
  if (
    !userRoles?.hasFullAccess &&
    getXClientIdHeader()["X-Client-Id"] === ServiceName.ANOBIS_IMCOM &&
    [userRoles?.pods, userRoles?.metrics, userRoles?.cities].some((item) => item?.length === 0)
  ){
    return false
  }
  return true
}

export default authenticationReducer;
